"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Getter = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _globals = _interopRequireDefault(require("../globals"));

var _registrar = _interopRequireDefault(require("../compiler/registrar"));

var _queryToProps = _interopRequireDefault(require("../component/query-to-props"));

var _get2 = _interopRequireDefault(require("lodash/get"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Getter = /*#__PURE__*/function () {
  function Getter(_ref) {
    var action = _ref.action,
        component = _ref.component,
        args = _ref.args,
        globals = _ref.globals;
    (0, _classCallCheck2.default)(this, Getter);
    this._action = action;
    this._component = component;
    this._args = args;
    this._globals = globals;
  }

  (0, _createClass2.default)(Getter, [{
    key: "get",
    value: function get(name) {
      var names = name.split('.');
      var firstName = names[0];
      var item;
      var isComponent = false;

      switch (firstName) {
        case 'action':
          item = this._action;
          break;

        case 'arguments':
          item = this._args;
          break;

        case 'globals':
          item = this._globals;
          break;

        default:
          isComponent = true;
          item = this._component;
          break;
      }

      if (item === undefined) {
        return undefined;
      } else if (names.length > 1 || isComponent) {
        var childName = name;

        if (!isComponent) {
          names.shift(); // remove first name

          childName = names.join('.');
        } // Is the item a getter?


        if (item.get && typeof item.get === 'function') {
          return item.get(childName);
        } else {
          // Item is an object
          return (0, _get2.default)(item, childName);
        }
      } else {
        return item;
      }
    }
  }]);
  return Getter;
}();

exports.Getter = Getter;

var ComponentFillerProps = /*#__PURE__*/function () {
  function ComponentFillerProps() {
    (0, _classCallCheck2.default)(this, ComponentFillerProps);
    // For mocking
    this._registrar = _registrar.default;
  }

  (0, _createClass2.default)(ComponentFillerProps, [{
    key: "_getSession",
    value: function _getSession() {
      var reg = this._registrar;
      return reg.client ? reg.client.user.getSession() : undefined;
    } // TODO: refactor so that we just expose the globals component and a session property. This way,
    // we don't process the properties until they are needed. The session property can probably be on
    // globals and simply return a session when it is retrieved, e.g. see FormEditor and the
    // definition property for a similar example.

  }, {
    key: "_getGlobals",
    value: function _getGlobals() {
      return _objectSpread({
        session: this._getSession()
      }, _globals.default.get());
    }
  }, {
    key: "getFillerProps",
    value: function getFillerProps(props) {
      // Wrap in a Getter so that we expose a single get() to PropFiller
      return new Getter({
        action: props && props.parent,
        component: props && props.component,
        args: props && props.arguments,
        globals: this._getGlobals()
      });
    }
  }, {
    key: "getWhereProps",
    value: function getWhereProps(where, props) {
      // Wrap in a Getter so that we expose a single get() to queryToProps()
      var component = new Getter({
        action: props.parent,
        component: props.component,
        args: props.arguments,
        globals: this._getGlobals()
      });
      return (0, _queryToProps.default)(where, component);
    }
  }]);
  return ComponentFillerProps;
}();

exports.default = ComponentFillerProps;